var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.963,
    height: 60,
    viewBox: "0 0 51.963 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-check",
    transform: "translate(-108.645 -18.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89939",
    "data-name": "Path 89939",
    d: "M196.919,127.715a9.437,9.437,0,0,1-5.716,8.8,8.521,8.521,0,0,1-9.763-2.787,9.942,9.942,0,0,1-.788-10.8,8.645,8.645,0,0,1,9.18-4.425,9.313,9.313,0,0,1,7.086,9.212,1.575,1.575,0,0,0,3.149,0,12.655,12.655,0,0,0-7.826-11.763,11.588,11.588,0,0,0-13.132,3.685,13.125,13.125,0,0,0-1.1,14.55,11.8,11.8,0,0,0,12.582,5.795c5.7-1.181,9.448-6.629,9.5-12.266a1.584,1.584,0,0,0-3.165,0Z",
    transform: "translate(-58.152 -83.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89940",
    "data-name": "Path 89940",
    d: "M111.794,349.491a11.673,11.673,0,0,1,.835-5.244,9.528,9.528,0,0,1,4.583-4.583c2.252-1.071,4.819-.835,7.243-.835h10.156c2.22,0,4.724-.267,6.881.3a9.357,9.357,0,0,1,5.638,4.283,11.422,11.422,0,0,1,1.26,6.078,1.575,1.575,0,0,0,3.149,0,15.279,15.279,0,0,0-1.134-6.551,12.3,12.3,0,0,0-5.2-5.653c-2.913-1.638-5.984-1.59-9.18-1.59H125.289c-2.756,0-5.716-.252-8.346.693a12.5,12.5,0,0,0-6.755,5.716,14.8,14.8,0,0,0-1.543,7.385,1.575,1.575,0,0,0,3.149,0Z",
    transform: "translate(0 -272.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89941",
    "data-name": "Path 89941",
    d: "M391.511,182.366l4.307,4.764a1.031,1.031,0,0,0,1.432,0q5.18-4.464,10.361-8.919c.487-.427.985-.843,1.473-1.27a1.013,1.013,0,0,0-1.432-1.432q-5.18,4.464-10.361,8.919c-.487.427-.985.843-1.473,1.27h1.432l-4.307-4.764C392.07,179.959,390.638,181.4,391.511,182.366Z",
    transform: "translate(-248.77 -157.14)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/user-check.cc3d64c341f461ad357c58f8c0243205.svg";
export { ForwardRef as ReactComponent };